// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"497":"77d38021","767":"aeca694f"}[chunkId] + ".js";
};